/**
 * Removes item from array.
 *
 * Also
 * ```
 * items.filter((item) => item !== value)
 * ```
 * can be easily used.
 *
 * @param array required
 * @param value required
 * @returns
 */
export function removeItem(array, value) {
    const index = array.indexOf(value);
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
}
export function removeItemById(array, id) {
    const listItemIndex = array.findIndex((item) => item.id === id);
    if (listItemIndex > -1) {
        array.splice(listItemIndex, 1);
    }
    return array;
}
/**
 * `.filter()` is faster than `.splice()` in this case, however creates a new array.
 *
 * @returns new array without items with specified its.
 */
export function removeItemsByIds(array, itemIds, idField) {
    return array.filter((item) => !itemIds.includes(item[idField]));
}
export function removeItemByIndex(array, index) {
    if (index > -1) {
        array.splice(index, 1);
    }
    return array;
}
/**
 * Adds item to **sorted** array with sorting by `id` field, specified with `idField` parameter.
 *
 * @returns an index of the added item
 */
export function addItemToSorted(array, item, idField, orderBy) {
    if (orderBy === 'desc') {
        // Starting with 0 index element, assuming that new item has higher id.
        for (let index = 0; index < array.length; index++) {
            if (array[index][idField] > item[idField])
                continue;
            array.splice(index, 0, item);
            return index;
        }
        const newLength = array.push(item);
        return newLength - 1;
    }
    // 'asc'
    for (let index = array.length - 1; index >= 0; index--) {
        if (array[index][idField] > item[idField])
            continue;
        array.splice(index + 1, 0, item);
        return index + 1;
    }
    array.unshift(item);
    return 0;
}
export function areValuesUnique(...values) {
    return new Set(values).size === values.length;
}
